
const CeremonyType = (cell) => {
    return cell.value ? cell.value : '';
};
const Price = (cell) => {
  return cell.value ? cell.value : '';
};


const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export { CeremonyType,Price, IsActive }